module.exports = __webpack_public_path__ + "static/media/star-solid.1e95437f.svg";